var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWreath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 24,
    viewBox: "0 0 11 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leaderboard-Mobile---Race-Not-Started-(Registered)",
    transform: "translate(-88 -310)",
    fill: "#F8E780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leaderboard-and-BG",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leaderboard",
    transform: "translate(-12 270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prize",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wreath-Copy-2",
    transform: "rotate(22 -30.957 285.728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.947 14.024c-.255 0-.51.04-.756.125-.112.04-.16.173-.11.283.188.4.414.758.678 1.04.326.32.682.552 1.038.683.222.077.445.113.665.113a2.08 2.08 0 001.227-.412.224.224 0 00.041-.312 5.432 5.432 0 00-.66-.689c-.283-.246-.636-.42-.956-.575a2.949 2.949 0 00-1.167-.256",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.142 11.78a.165.165 0 00-.086.025 2.676 2.676 0 00-1.164 1.496c-.125.366-.133.732-.1 1.124.023.322.12.625.264.907.032.062.084.095.139.095.04 0 .081-.018.115-.056.461-.51.747-1.159.911-1.773a3.45 3.45 0 00.144-.992 2.472 2.472 0 00-.06-.688c-.023-.087-.09-.138-.163-.138",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.193 12.493c.387.274.802.41 1.217.41.214 0 .428-.036.638-.107.11-.038.165-.17.12-.281a4.189 4.189 0 00-1.218-1.701c-.485-.422-1.093-.716-1.726-.716H.178c-.115.003-.195.113-.175.231.076.439.192.849.388 1.195.225.404.5.734.802.969",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.741 10.108c.05-.218.097-.441.096-.663a.188.188 0 00-.223-.185 2.364 2.364 0 00-1.52 1 2.534 2.534 0 00-.307 1.943c.021.086.09.138.165.138a.173.173 0 00.084-.022c.578-.318 1.03-.828 1.321-1.335.18-.29.314-.586.384-.876",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.66 8.624c.478.603 1.101.913 1.775.913h.013a.213.213 0 00.204-.24c-.041-.354-.146-.69-.244-1.012a4.25 4.25 0 00-.55-1.09C1.47 6.6.916 6.097.256 5.898a.181.181 0 00-.054-.008c-.096 0-.176.076-.184.181a5.208 5.208 0 00-.017.573c.004.26.032.51.1.75.123.476.307.896.559 1.23",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.184 9.057c-.002.113.076.2.175.2.01 0 .022-.002.033-.004.635-.123 1.197-.476 1.604-.88.237-.228.446-.475.583-.74.064-.132.132-.268.187-.408.026-.07.048-.142.065-.216.029-.121-.054-.242-.168-.257a2.56 2.56 0 00-.32-.02c-.516 0-.996.164-1.395.504a2.394 2.394 0 00-.594.878c-.126.288-.166.609-.17.943",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.384 5.881a.17.17 0 00.054.01c.088 0 .168-.073.181-.176.048-.35.036-.703.02-1.043A4.594 4.594 0 002.4 3.457c-.206-.69-.579-1.346-1.12-1.742a.162.162 0 00-.095-.032c-.069 0-.133.046-.16.126-.32.927-.287 1.91-.018 2.643.285.73.771 1.222 1.376 1.429",
    id: "Fill-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.616 6.143c.133.02.265.028.395.028.525 0 1.024-.142 1.43-.349.52-.249.914-.592 1.165-1.047a.226.226 0 00-.096-.307c-.356-.17-.72-.26-1.075-.26-.261 0-.518.048-.765.148-.3.14-.578.364-.811.66-.19.24-.314.54-.402.865-.034.123.04.246.159.262",
    id: "Fill-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.953 3.366a.169.169 0 00.08-.021c.554-.3.991-.725 1.29-1.249.182-.278.284-.624.385-.963.08-.284.123-.597.129-.933.002-.11-.077-.2-.175-.2-.009 0-.017 0-.026.002A2.102 2.102 0 004.858.3c-.312.184-.545.493-.753.818-.354.616-.49 1.397-.314 2.112.022.085.089.136.162.136",
    id: "Fill-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43 22.876c.156.053.312.096.47.11a3.442 3.442 0 00.656-.005c.212-.024.412-.065.602-.137.192-.08.369-.18.53-.296.324-.232.58-.529.759-.876.147-.294.243-.62.286-.963a.202.202 0 00-.192-.232l-.096-.001c-.268 0-.529.022-.785.103-.354.104-.689.22-1.01.428-.158.1-.311.216-.457.345a3.266 3.266 0 00-.4.4 2.897 2.897 0 00-.493.838.222.222 0 00.13.286",
    id: "Fill-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.873 18.676a4.528 4.528 0 00-.373-1.033 3.053 3.053 0 00-.252-.41 2.827 2.827 0 00-.28-.363 1.57 1.57 0 00-.318-.265c-.057-.034-.251-.076-.309-.11-.024-.016-.168.054-.193.054-.073 0-.14.058-.161.146a3.79 3.79 0 00-.108.97c.006.194.026.387.066.57.041.178.1.347.176.508.152.314.367.629.645.825.223.15.477.288.753.343a.175.175 0 00.033.004c.1 0 .439-.163.439-.273a4.15 4.15 0 00-.118-.966z",
    id: "Fill-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.962 21.538c.157.041.315.06.47.06.243 0 .479-.044.695-.11.648-.192 1.142-.708 1.41-1.388.043-.112-.014-.243-.124-.282a3.282 3.282 0 00-1.092-.184c-.272 0-.541.032-.806.091-.629.168-1.224.486-1.637 1.053a.23.23 0 00.046.312c.328.236.697.362 1.038.448",
    id: "Fill-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.681 19.05a.187.187 0 00.27-.119c.193-.71.15-1.425.013-2.05a3.944 3.944 0 00-.347-.9 1.784 1.784 0 00-.402-.501.191.191 0 00-.13-.053.177.177 0 00-.153.092c-.368.634-.532 1.344-.394 1.984a2.169 2.169 0 001.143 1.548",
    id: "Fill-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.854 18.448a.225.225 0 00-.049-.315 4.003 4.003 0 00-.811-.47 3.098 3.098 0 00-.539-.162 3.153 3.153 0 00-.818-.11c-.572 0-1.157.154-1.635.515a.224.224 0 00-.032.318c.28.335.603.597.925.796a2.563 2.563 0 001.261.334c.354 0 .692-.093 1-.277.266-.156.5-.369.698-.629",
    id: "Fill-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.387 16.091c.029.172.075.344.139.51.1.271.242.534.437.74a.15.15 0 00.11.05.164.164 0 00.143-.095c.144-.276.25-.568.323-.858.086-.35.137-.713.151-1.061a3.68 3.68 0 00-.086-.947 1.889 1.889 0 00-.214-.6.155.155 0 00-.135-.086.159.159 0 00-.118.056 2.872 2.872 0 00-.75 2.291",
    id: "Fill-32"
  })))))))));
}

SvgWreath.displayName = 'Wreath';
export default SvgWreath;